import{isElement as n}from"./instanceOf.js";function e(e){return((n(e)?e.ownerDocument:e.document)||window.document).documentElement}export{e as default};
